import React, { createContext, useContext, ReactNode } from 'react';
import { QuestContextType } from '@/types/quest-types';
import { useQuestSystem } from '@/hooks/onboarding/useQuestSystem';

const QuestContext = createContext<QuestContextType | undefined>(undefined);

interface QuestProviderProps {
  children: ReactNode;
}

export const QuestProvider: React.FC<QuestProviderProps> = ({ children }) => {
  const questSystem = useQuestSystem();

  return (
    <QuestContext.Provider value={questSystem}>
      {children}
    </QuestContext.Provider>
  );
};

export const useQuest = (): QuestContextType => {
  const context = useContext(QuestContext);
  if (context === undefined) {
    throw new Error('useQuest must be used within a QuestProvider');
  }
  return context;
};

export default QuestContext;